/**
 * Does this login hold a server gate key? Mirrors backend core/auth/gates.ts: STRICT — only a key listed in the
 * role's permissions counts ("*" does not). The server still decides every request; this only chooses what to show.
 * Per-user on/off overrides are not visible here, so the server's answer wins when it differs.
 */
export function userHoldsGate(user: { role?: { permissions?: string[] | null } | null } | null | undefined, key: string): boolean {
  const list = user?.role?.permissions;
  return Array.isArray(list) && list.includes(key);
}
export function userHoldsAnyGate(user: { role?: { permissions?: string[] | null } | null } | null | undefined, keys: readonly string[]): boolean {
  return keys.some((k) => userHoldsGate(user, k));
}
